import filterRowsWithDifference from './filterRowsWithDifference';

const toggleRowsWithDifference = (table, switcher) => {
  if (!table) throw Error('No table found');
  if (!switcher) throw Error('No switcher found');

  const isSwitcherChecked = switcher.checked;
  const tableRows = [...table.querySelectorAll('tbody tr')];
  const rowsWithDifference = filterRowsWithDifference(table);

  if (isSwitcherChecked) {
    tableRows.forEach((row) => row.classList.add('hidden'));
    rowsWithDifference.forEach((row) => row.classList.remove('hidden'));
  } else {
    tableRows.forEach((row) => row.classList.remove('hidden'));
  }
};

export default toggleRowsWithDifference;
